import React, { useState } from "react";
import {Grid, Link, Typography, Button} from "@mui/material";
import useUntoldAdvertisingStyles from "../styles/untold/untoldAdvertising";
import {NavLink} from "react-router-dom";
import {paths} from "../AppRouters";
import prize_untold from '../assets/images/untold/prize_untold.png';
import banner_text_2_rows from '../assets/images/untold/banner_text_2_rows.png';
import logo_untold_kozel_meeet from '../assets/images/untold/logo_untold_kozel_meeet.png';
import influencers_contrast from '../assets/images/untold/influencers_contrast.png';
import InfoIcon from '@mui/icons-material/Info';
import {useAppSelector} from "../stores/store";
import Carousel from "react-material-ui-carousel";
import useCarouselStyles from "../styles/kozel/carouselStyles";
import clsx from "clsx";
import useMeetInfluencers from "../styles/kozelMeet/meetInfluencers";
import message_icon1 from '../assets/images/untold/message_icon1.png';
import message_icon2 from '../assets/images/untold/message_icon2.png';
import message_icon3 from '../assets/images/untold/message_icon3.png';
import message_mobile_icon1 from '../assets/images/untold/message_icon1_mobile.png';
import message_mobile_icon2 from '../assets/images/untold/message_icon2_mobile.png';
import message_mobile_icon3 from '../assets/images/untold/message_icon3_mobile.png';
import clock_icon from '../assets/images/untold/clock_icon.png';
import useIsScreenDownLg from "../hooks/useIsScreenDownLg";
import theme from "../styles/themes/default";
import TeaserFrame2 from "../components/TeaserFrame2";
import PopupComponent from "../components/kozel/PopupComponent";
import map_challenge_untold from '../assets/images/untold/map_challenge_untold.png';


const UntoldAdvertising: React.FC = () => {
    const styles = useUntoldAdvertisingStyles();
    const stylesInfluencer = useMeetInfluencers();
    const [isOpenPopupMap, setIsOpenPopupMap] = useState(false);
    const isScreenDownLg = useIsScreenDownLg();
    const carouselStyles = useCarouselStyles();
    const {isAuthenticated} = useAppSelector(state => state.auth);

    return (
        <Grid container className={styles.wrapperContainer}>
            <Grid item xs={12}>
                <Carousel
                    className={carouselStyles.carousel}
                    navButtonsAlwaysInvisible
                    animation={'fade'}
                    indicators={true}
                    autoPlay={false}
                    stopAutoPlayOnHover={true}
                    indicatorContainerProps={{
                        className: carouselStyles.indicatorContainer
                    }}
                    indicatorIconButtonProps={{
                        className: carouselStyles.indicator
                    }}
                    activeIndicatorIconButtonProps={{
                        className: carouselStyles.activeIndicator
                    }}
                >
                    {/* <Grid container className={styles.containerS1}>
                        <Grid item xs={12} lg={6} className={styles.containerS1Item}>
                            <img src={banner_text_2_rows} alt={'banner_text_2_rows'}
                                 className={styles.teaserTitleUntold}/>
                            {<Typography className={styles.subtitleTeaser}>Cumpără Kozel, înscrie codul bonului pe site
                                și
                                câștigă premii de FESTIVAL</Typography>}
                            <NavLink to={paths.ncp} className={styles.button}>Înscrie bonul</NavLink>
                        </Grid>
                        <Grid item xs={12} lg={6} className={clsx(styles.containerS1Item, styles.wrapperImgPrize)}>
                            <img src={prize_untold} alt={'prize_untold'} className={styles.containerS1ItemImgPrize}/>
                        </Grid>
                    </Grid> */}
                    <Grid container className={styles.containerS1}>
                        <Grid item xs={12} className={styles.containerS1Item}>
                            <img src={banner_text_2_rows} alt={'banner_text_2_rows'}
                                 className={styles.teaserTitleUntold}/>
                            <Typography className={styles.subtitleTeaser}>
                                {isAuthenticated ? <> Create your team and come at UNTOLD, at Kozel Meet area and the Giant Bar besides the Ferris Wheel!
                                    <span className={'textGold'}>GOAT Challenges await you here</span></> : <>
                                    Join Kozel Community,
                                    participate at the activations and win prizes and points!
                                    <span
                                        className={'textGold'}>It’s super easy! Join only by phone number!</span></>}
                            </Typography>
                            {isAuthenticated ?
                                <NavLink to={paths.myGroup} className={styles.button}>I CREATE MY TEAM</NavLink> :
                                <NavLink to={paths.register} className={styles.button}>I JOIN THE COMMUNITY</NavLink>}

                                <Typography className={styles.commercialText}><InfoIcon/>
                                    {isAuthenticated ?
                                        'each friend that you invite brings the team 10 extra points' :
                                        'joining the community brings you 50 points'}
                                </Typography>
                        </Grid>
                    </Grid>
                </Carousel>
            </Grid>
            <Grid item xs={12} lg={10} className={styles.wrapperContainerItem}>
                <Grid container className={styles.containerComeUntold}>
                    <Grid item xs={12}>
                        <img src={logo_untold_kozel_meeet} alt={'logo_untold_kozel_meeet'} className={styles.img}/>
                    </Grid>
                    <Grid item xs={12} className={styles.wrapperTitle}>
                        <Typography className={styles.title}>The waiting is OVER!</Typography>
                    </Grid>
                    <Grid item xs={12} className={styles.wrapperSubtitle}>
                        <Typography className={styles.subtitle}>Let the challenge begin!</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} lg={6} className={styles.wrapperImgInf}>
                                <img src={influencers_contrast} alt={'influencers_contrast'} className={styles.img}/>
                            </Grid>
                            <Grid item xs={12} lg={6} className={styles.wrapperText}>
                                <Grid container>
                                    <Grid item xs={12} className={styles.boxText1}>
                                        <Typography className={styles.text}>
                                            <Link href={'https://www.instagram.com/lauramusuroaea/'}
                                                  target="_blank">@LauraMușuroaea</Link>,
                                            &nbsp;<Link href={'https://www.instagram.com/mariciu/'}
                                                        target="_blank">@Mariciu</Link>&nbsp;and&nbsp;
                                            <Link href={'https://www.instagram.com/vladgrigorescu/'}
                                                  target="_blank">@VladGrigorescu</Link>&nbsp;
                                             are already here with their teams and have started the challenges at UNTOLD!
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography className={styles.text}>Participate with your group of friends or with The new friends you make here,
                                             solve all the Challenges and enjoy the taste of GOATIFUL beer From the Czech Republic!
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

             <Grid item xs={12} className={stylesInfluencer.wrapperTeaser}>
                <TeaserFrame2
                    title={<Typography className={stylesInfluencer.teaserTitle}>WHAT IS THE PLAN?</Typography>}
                    titleMarginTop={'min(-5vh,-5vw)'}
                    backgroundBoxTitle={theme.colors.dark_chocolate}
                >
                    <Grid container>
                        <Grid item xs={12} className={stylesInfluencer.teaserWrapperItem}>
                            <Grid container className={stylesInfluencer.teaserContainer}>
                                <Grid item xs={12} lg={4} className={clsx(stylesInfluencer.teaserItem, stylesInfluencer.boxImg)}>
                                    {isScreenDownLg ?
                                        <img src={message_mobile_icon1} alt={'message_mobile_icon1'}
                                            className={stylesInfluencer.img} /> :
                                        <img src={message_icon1} alt={'message_icon1'} className={styles.img} />}
                                </Grid>
                                <Grid item xs={12} lg={8} className={clsx(stylesInfluencer.teaserItem, stylesInfluencer.boxText)}>
                                    <Typography className={stylesInfluencer.teaserText}>Make sure you have the gang! Whether you came together 
                                        or you connected here,you’re sure to have a blast!
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={stylesInfluencer.teaserWrapperItem}>
                            <Grid container className={stylesInfluencer.teaserContainer}>
                                <Grid item xs={12} lg={8} className={clsx(stylesInfluencer.teaserItem, stylesInfluencer.boxText)}>
                                    <Typography
                                        className={clsx(stylesInfluencer.teaserText, isScreenDownLg ? '' : stylesInfluencer.textRight)}>Go to Kozel Island, scan the QR codes,
                                        and solve all challenges with your team!
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} lg={4} className={clsx(stylesInfluencer.teaserItem, stylesInfluencer.boxImg)}>
                                    {isScreenDownLg ?
                                        <img src={message_mobile_icon2} alt={'message_mobile_icon2'}
                                            className={stylesInfluencer.img} /> :
                                        <img src={message_icon2} alt={'message_icon2'} className={styles.img} />}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={stylesInfluencer.teaserWrapperItem}>
                            <Grid container className={stylesInfluencer.teaserContainer}>
                                <Grid item xs={12} lg={4} className={clsx(stylesInfluencer.teaserItem, stylesInfluencer.boxImg)}>
                                    {isScreenDownLg ?
                                        <img src={message_mobile_icon3} alt={'message_mobile_icon2'}
                                            className={stylesInfluencer.img} /> :
                                        <img src={message_icon3} alt={'message_icon3'} className={stylesInfluencer.img} />}
                                </Grid>
                                <Grid item xs={12} lg={8} className={clsx(stylesInfluencer.teaserItem, stylesInfluencer.boxText)}>
                                    <Typography className={stylesInfluencer.teaserText}>Go to KOZEL MEEET area next to the giant Bar. 
                                        Celebrate with friends, because there’s Always room for one more friend!
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </TeaserFrame2>
            </Grid> 
            
             {isAuthenticated && <Grid item xs={12} className={clsx(stylesInfluencer.containerItem, stylesInfluencer.mapBox)}>
                <Typography className={stylesInfluencer.textGoMap}>Access the map and come to Kozel GOAT Land to START the fun and prizes </Typography>
                <Button className={stylesInfluencer.button} onClick={() => {
                    setIsOpenPopupMap(true)
                }}>SEE THE MAP HERE</Button>
                <img src={clock_icon} alt={'clock_icon'} className={stylesInfluencer.img} style={{ maxWidth: '200px' }} />
            </Grid>}
            {isAuthenticated && <Grid item xs={12} className={clsx(stylesInfluencer.containerItem, stylesInfluencer.mapBox)}>
                <Typography className={stylesInfluencer.titleRitual}>THE ELEVATING BEER RITUAL</Typography>
                <Grid container className={stylesInfluencer.timeIntervalWrapperContainer}>
                    <Grid item xs={12} className={stylesInfluencer.timeIntervalWrapperItem}>
                        <Grid container className={stylesInfluencer.timeIntervalContainer}>
                            <Grid item className={stylesInfluencer.boxTime}>21:00</Grid>
                            <Grid item className={stylesInfluencer.boxClockIcon}>
                                <img src={clock_icon} alt={'clock_icon'} className={stylesInfluencer.img} />
                            </Grid>
                            <Grid item className={stylesInfluencer.boxTime}>22:00</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>}
            
            {isAuthenticated && <Grid item xs={12} className={stylesInfluencer.containerItem}>
                <Typography className={stylesInfluencer.keepEyesOnUsTest}>Stay tuned, every evening from 21:00 and 22:00 you have a Kozel MIX beer from Us!
                     Make sure you are present at one of the 2 Kozel areas near the Giant Kozel Bar and Kozel Meeet House! </Typography>
            </Grid>}
            
            {isAuthenticated && <Grid item xs={12} className={stylesInfluencer.containerItem} sx={{
                marginBottom: { xs: '60px', md: '60px' } 
            }}>
                <Typography className={stylesInfluencer.prepareSurpriseText}>We are preparing a G.O.A.T surprise! </Typography>
            </Grid>}

            {isAuthenticated && (
                <PopupComponent isOpen={isOpenPopupMap} onClose={() => {
                    setIsOpenPopupMap(false)
                }}>
                    <img src={map_challenge_untold} alt={'map_challenge_untold'} className={styles.img} />
                </PopupComponent>
            )}     

        </Grid>
    )
}

export default UntoldAdvertising;